/**
 * Gravitee.io Portal Rest API
 * API dedicated to the devportal part of Gravitee
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: contact@graviteesource.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * type of Identity Provider
 */
export type IdentityProviderType = 'GOOGLE' | 'GITHUB' | 'GRAVITEEIO_AM' | 'OIDC';

export const IdentityProviderType = {
    GOOGLE: 'GOOGLE' as IdentityProviderType,
    GITHUB: 'GITHUB' as IdentityProviderType,
    GRAVITEEIOAM: 'GRAVITEEIO_AM' as IdentityProviderType,
    OIDC: 'OIDC' as IdentityProviderType
};

